<script setup lang="ts">
import { useCityStore } from '@/store/city/city'

import { DeliveryMethods } from '@/api/modules/basket/types'

type Props = {
  id?: number
  deliveryMethod?: DeliveryMethods
  orderAddress?: string
  cityDomainPrefix?: string
}

const props = defineProps<Props>()

const emits = defineEmits(['close-dialog-redirect-city'])

const cityStore = useCityStore()

const onCloseDialogDeleteAddress = () => {
  emits('close-dialog-redirect-city')
}

const onRedirectOtherCity = async () => {
  if (!props.cityDomainPrefix || !props.id) return

  const { origin } = useRequestURL()

  const newUrl = origin.replace(
    cityStore.cityInfo.domain_prefix,
    props.cityDomainPrefix,
  )

  const deliveryMethod = props.deliveryMethod || DeliveryMethods.COURIER

  const orderAddress = props.orderAddress
    ? `&orderAddress=${props.orderAddress}`
    : ''

  await navigateTo(
    `${newUrl}?addressId=${props.id}&deliveryMethod=${deliveryMethod}${orderAddress}`,
    {
      external: true,
    },
  )
}
</script>

<template>
  <div class="dialog-redirect">
    <h5 class="dialog-redirect__title">
      При смене города корзина может поменяться. Сменить адрес?
    </h5>

    <div class="dialog-redirect__actions">
      <the-button block variant="tertiary" @click="onCloseDialogDeleteAddress">
        Нет
      </the-button>

      <the-button variant="secondary" block @click="onRedirectOtherCity">
        Изменить адрес
      </the-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.dialog-redirect {
  padding-top: 16px;

  @include media('>=tablet') {
    padding-top: 0;
  }

  &__title {
    margin-bottom: 24px;
    font-size: 18px;
    font-weight: 800;
    line-height: 23px;
    color: var(--ui-text-primary);

    @include media('>=tablet') {
      max-width: 380px;
      margin: 0 auto 32px;
      text-align: center;
    }
  }

  &__actions {
    display: flex;
    flex-direction: column;
    gap: 16px;

    @include media('>=tablet') {
      max-width: 260px;
      margin: 0 auto;
    }
  }
}
</style>
